import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Colors } from "../theme";


export const StaffHeader = styled(Typography)(()=>({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding:'4px',
    flexGrow:1,
    fontSize: '4em',
    fontFamily:`"sans-serif" , "cursive"`,    
    color:Colors.secondary,
}));